module.exports = __webpack_public_path__ + "static/media/Intro_velvet.ffa58201.png";